import React from 'react'
import PropTypes from 'prop-types'
import c from 'classnames'

export function Finished({ className, model }) {
  return (
    <div className={c('process-finished', className)}>
      <img src="/images/ic-process-finished.png" alt="process finished" />
      <h5>
        Claim Process for Your
        {' '}
        {model}
        {' '}
        is Complete!
      </h5>
      <p>All steps have been completed successfully</p>
      <p>
        If you need any further assistance regarding this incident,
        {' '}
        <a href="/">contact us.</a>
      </p>
    </div>
  )
}
export default Finished

Finished.propTypes = {
  className: PropTypes.string,
  model: PropTypes.string,
}

Finished.defaultProps = {
  className: '',
  model: '',
}
